export default __webpack_public_path__ + "static/Ratajczak-7473d5815e77b95213fe7557c285bf6e.jpg";